export const conditionalFields = {
    "CITATIONS": '22ed3906-62fc-4469-8c05-cd86cb4735fa'
}